





















































































































































































































































import Vue from 'vue'
import Modal from '@/pmd/components/common/Modal.vue'
import Company from '@/models/api/Company'
import { User } from '@/models'
import { User as UserApi } from '@/models/api'
import { mapState } from 'vuex'
import { UserState } from '../../../store/state_models'
import moment from 'moment-timezone'
import countries from '@/util/countries'
import { trackGaPageView } from '@/util/helper'
import { isoToState } from '@/util/state_helper'
import defaults from '@/config'
import { OnboardingService } from '@/services'

import EyeIcon from '@/assets/pmd/img/icon-eye3.svg'
import GhlLogoIcon from '@/assets/pmd/img/icon-ghl-logo2.svg'

export default Vue.extend({
  props: ['userId'],
  components: {
    Modal,
    EyeIcon,
    GhlLogoIcon
  },
  data() {
    return {
      accepting: false,
      tandc: false,
      modalShow: false,
      countries: countries,
      address: '',
      addressLine: '',
      company: {} as Company,
      userInfo: {} as User,
      authUser: {} as any,
      isReselling: false,
      showReselling: true,
    }
  },
  async created() {
    this.$store.dispatch('init')
    this.authUser = await this.$store.dispatch('auth/get')
    this.userInfo = await UserApi.getById(this.authUser.userId)
    this.company = await Company.getById(this.userInfo.companyId)
    if (this.company.address) {
      this.address = this.company.address
    }
    if (this.company.isReselling) {
       this.isReselling = this.company.isReselling
       this.showReselling = false
    }
    this.isTermOfServiceAccepted()
  },
  computed: {
    disabled() {
      return !this.tandc
    },
    ...mapState('user', {
      user: (s: UserState) => {
        return s.user ? new User(s.user) : undefined
      },
    }),
    twStates() {
      return Object.entries(isoToState).map((state: any) => {
        return {
          value: state[0],
          label: state[1]
        }
      })
    },
    twCountries() {
      return Object.entries(countries).map((country: any) => {
        return {
          value: country[0],
          label: country[1]
        }
      })
    },
  },
  methods: {
    async isTermOfServiceAccepted() {
      if (this.user.id && !this.company.onboardingInfo?.pending && this.user.type == 'agency' &&
          this.user.role == 'admin') {
        if (!this.company.termsOfServiceVersion ||
        this.company.termsOfServiceVersion !== defaults.tosVersion) {
          try {
            const termsOfServicePopup = await this.$http.get(
              `/terms_of_service_popup`
            )
            if (termsOfServicePopup.data.terms_of_service_popup)
              this.modalShow = true
          } catch (error) {
            console.log(error)
          }
        }
      }
    },
    async validateBeforeSubmit() {
      const result = await this.$validator.validateAll('form-tandc')

      if (!result) {
        console.error('Correct them errors!', this.$validator.errors)
        return false
      }
      this.accepting = true
      this.company.termsOfServiceAcceptedBy = this.userId
      this.company.termsOfServiceAcceptedDate = moment().utc()
      this.company.termsOfServiceVersion = defaults.tosVersion
      this.company.privacyPolicyAcceptedBy = this.userId
      this.company.privacyPolicyAcceptedDate = moment().utc()
      this.company.privacyPolicyVersion = defaults.privacyPolicyVersion
      this.company.affiliatePolicyAcceptedBy = this.userId
      this.company.affiliatePolicyAcceptedDate = moment().utc()
      this.company.affiliatePolicyVersion = defaults.affiliatePolicyVersion
      this.company.address = this.address
      this.company.isReselling = this.isReselling
      if (this.addressLine) this.company.address += `, ${this.addressLine}`
      await this.company.save()
      let termsOfserviceAcceptedDate = moment()
        .utc()
        .format('MMM. D, YYYY [at] h:mm A z')
      if (this.company.timezone) {
        termsOfserviceAcceptedDate = moment()
          .tz(this.company.timezone)
          .format('MMM. D, YYYY [at] h:mm A z')
      }

      try {
        await this.createTosLog()
        await Promise.all([
          this.$http.put('/onboarding/customer_update', {
            metadata: {
              reseller: this.company.isReselling ? 'Yes' : 'No',
              tos_accepted_by: this.user?.fullName,
              tos_accepted_date: termsOfserviceAcceptedDate,
              pp_accepted_by: this.user?.fullName,
              pp_accepted_date: termsOfserviceAcceptedDate,
              tos_version: moment(defaults.tosVersion).format('MMM DD YYYY'),
              pp_version: moment(defaults.privacyPolicyVersion).format('MMM DD YYYY')
            },
          }),
          this.$http.post('/onboarding', {
            is_reselling: this.company.isReselling ? 'Yes' : 'No',
          }),
        ])
      } catch (error) {
        console.log(error)
      }
      this.accepting = false
      this.modalShow = false
      trackGaPageView('onb-biz-address')
      this.$root.$emit('billing_address_update')
    },
    clearState() {
      this.company.state = ''
    },
    async createTosLog() {
      try {
        await OnboardingService.createTosLogs({
          userId: this.user.id,
          companyId: this.company.id,
          version: defaults.tosVersion
        })
      } catch (error) {
        console.log(error)
      }
    },
  },
})
